import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { Prospect } from 'crono-fe-common/types/prospect';

export default function useGetProspect(
  prospectId?: string | null,
  withExternalProperties = true,
  withSequenceInstance = true,
  withAccount = true,
  withScore = false,
) {
  const request = createGetProspectRequest(
    prospectId,
    withExternalProperties,
    withSequenceInstance,
    withAccount,
    withScore,
  );

  const requestConfig = {
    queryKey: [
      ENDPOINTS.prospect.main,
      prospectId,
      withSequenceInstance,
      withExternalProperties,
      withAccount,
      withScore,
    ],
    queryFn: () => {
      return client(request);
    },
    staleTime: 60 * 1000,
    enabled: !!prospectId,
    keepPreviousData: true,
  };

  const { data, ...rest } = useQuery<Response<Prospect | null>, CronoError>(
    requestConfig,
  );

  return { data, ...rest };

  // return useQuery<Response<Prospect>, CronoError>(requestConfig);
}

export function createGetProspectRequest(
  prospectId?: string | null,
  withExternalProperties = true,
  withSequenceInstance = true,
  withAccount = true,
  withScore = false,
): Request {
  const queryParams = new URLSearchParams({
    withExternalProperties: withExternalProperties ? 'true' : 'false',
    withSequenceInstance: withSequenceInstance ? 'true' : 'false',
    withAccount: withAccount ? 'true' : 'false',
    withScore: withScore ? 'true' : 'false',
  }).toString();
  return {
    url: `${ENDPOINTS.prospect.main}/${prospectId}?${queryParams}`,
    config: {
      method: 'get',
    },
  };
}
